import { render, staticRenderFns } from "./app.vue?vue&type=template&id=0a137e4e&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/DEV/gitlab/lenox/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a137e4e')) {
      api.createRecord('0a137e4e', component.options)
    } else {
      api.reload('0a137e4e', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=0a137e4e&", function () {
      api.rerender('0a137e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/personalize/app.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ../assets/js/personalize/app.vue
// module id = 79
// module chunks = 0